import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemParameter} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {TextArea, Input} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';

class Parameter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      moTa: '',
      giaTri: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,
      isValid: true
    };
  }

  componentDidMount() {
    this.getListData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getThamSo.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.thamSoes,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.setState({pageData: {
      ...this.state.pageData,
      size: size,
      number: 0
    }}, () => {
      this.getListData();
    })
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  createCategory() {
    if(this.validateSubmitForm()){
      let params = {
        ten: this.state.ten,
        moTa: this.state.moTa,
        giaTri: this.state.giaTri
      };
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        this.props.danhMuc.updateThamSo({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postThamSo('',params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
    }
  }

  handlePageClick(page) {
    this.setState({pageData: {
      ...this.state.pageData,
      number: page.selected
    }}, () => {
      this.getListData();
    })
  }

  handleDelete(categoryId) {
     if(categoryId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteThamSo({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
      });
     }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  openDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
  }

  closeDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    //
  }

  openAddNewCategory() {
    this.openDialog();
    this.setState({
      addType: 0,
      ten: '',
      moTa: '',
      giaTri: '',
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.openDialog();
    this.setState({
      addType:2,
      ten: item.ten,
      moTa: item.moTa,
      giaTri: item.giaTri,
      categoryId: item.thamSoId,
      isValid: true
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Tham Số</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('THAMSO_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <Search parents={this}/>
            <DataTable
              header = {header.categoryGroup.parameter}
              dataList={this.state.data}
              pageData={this.state.pageData}
              parent= {this}
              hideButtonExport
              tableLoading = {this.state.tableLoading}
            >
              <RowItemParameter/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.closeDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa tham số' : 'Thêm mới tham số'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <Input className="" label="Tên" value={this.state.ten} bindValidator={this} channel="formTaoDon" require maxLength={255} onChange={this.onChange.bind(this, 'ten')}/>
              <Input className="" label="Giá trị" value={this.state.giaTri} bindValidator={this} channel="formTaoDon" require maxLength={255} onChange={this.onChange.bind(this, 'giaTri')}/>
              <TextArea label="Mô tả" rows={5} maxLength={255} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className=''/>
            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                  <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
                </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

Parameter.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(Parameter);



// WEBPACK FOOTER //
// ./src/components/modules/category/Parameter.jsx